import {createFileRoute} from '@tanstack/react-router';
import {useTranslation} from 'tolgee';

import {EmptyContent} from '~components/common/EmptyContent';
import {BaseLayout} from '~components/_layout/BaseLayout';

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
});

function NotFoundPage() {
  const {t} = useTranslation('common');

  return (
    <BaseLayout>
      <EmptyContent title={t('errorPageNotFound')} />
    </BaseLayout>
  );
}
